import { Component, HostListener, OnInit, inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { Router, RouterOutlet } from "@angular/router";
import { DefaultComponent } from "@kpx/core";
import { STORAGE } from "../types/storage.config";
import { LoadingComponent } from "./components/screens/loading/loading.component";
import { HeaderComponent } from "./components/shared/header/header.component";
import { ActionService } from "./services/action.service";
import { ApplicationService } from "./services/application.service";
import { SessionService, SessionStatus } from "./services/session.service";

export interface Notification {
  id: string;
  message: string;
}

export interface NotificationStorage {
  id: string;
  notify: boolean;
}

@Component({
  selector: "app-root",
  imports: [HeaderComponent, MatIconModule, RouterOutlet, MatProgressSpinnerModule, LoadingComponent],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.less"],
})
export class AppComponent extends DefaultComponent implements OnInit {
  private application: ApplicationService;
  private session: SessionService;
  private actionService: ActionService;
  private router: Router;

  public notifications: Notification[];
  public authorizePending: boolean;
  public servicesLoading: boolean;
  public loading: boolean;

  public constructor() {
    super();
    this.application = inject(ApplicationService);
    this.session = inject(SessionService);
    this.actionService = inject(ActionService);
    this.router = inject(Router);

    this.notifications = [];
    this.authorizePending = false;
    this.servicesLoading = false;
    this.loading = false;

    this.application.busy.subscribe((state) => (this.loading = state));
    this.session.status.subscribe((status) => this.onSessionStatus(status));
  }

  public async ngOnInit(): Promise<void> {
    this.addNotification({
      id: "note1",
      message: `De Digitaal op de Kaart Quickscans hebben vanaf nu een nieuw invoerveld 'Eigen kenmerk' t.b.v. facturatiekenmerken. Daarnaast beschikken diverse invoervelden over een informatieknop met een aanvullende uitleg rondom dit veld.`,
    });
  }

  public getNotification(key: string): NotificationStorage | null {
    const notificationsString = localStorage.getItem(STORAGE.NOTIFICATIONS);
    if (notificationsString) {
      const notifications: NotificationStorage[] = JSON.parse(notificationsString);
      return notifications.find((n) => n.id == key) || null;
    }
    return null;
  }

  public isNotify(key: string): boolean {
    const notificationsString = localStorage.getItem(STORAGE.NOTIFICATIONS);
    if (notificationsString) {
      const notifications: NotificationStorage[] = JSON.parse(notificationsString);
      const note = notifications.find((n) => n.id == key);
      if (note) return note.notify;
    }
    return false;
  }

  public setNotify(key: string, value = true): void {
    let notifications: NotificationStorage[] = [];
    const notificationsString = localStorage.getItem(STORAGE.NOTIFICATIONS);

    try {
      if (notificationsString) {
        notifications = JSON.parse(notificationsString);
        const note = notifications.find((n) => n.id == key);
        if (note) {
          note.notify = value;
        } else {
          throw new Error("couldnt find note");
        }
      } else {
        throw new Error("couldnt find notificationsString");
      }
    } catch (ex) {
      notifications.push({
        id: key,
        notify: value,
      });
    } finally {
      localStorage.setItem(STORAGE.NOTIFICATIONS, JSON.stringify(notifications));
    }
  }

  public addNotification(...notifications: Notification[]): void {
    for (const notification of notifications) {
      if (this.getNotification(notification.id) == null) this.setNotify(notification.id, true);
      this.notifications.push(notification);
    }
  }

  public closeNotification(key: string): void {
    this.setNotify(key, false);
    this.notifications.filter((note) => note.id != key);
  }

  @HostListener("window:click", ["$event"])
  public listen(event: MouseEvent): void {
    this.actionService.handleClick(event);
  }

  private onSessionStatus(status: SessionStatus): void {
    this.servicesLoading = status === SessionStatus.IN_PROGRESS;
    this.authorizePending = status === SessionStatus.DEFAULT;

    if (status === SessionStatus.UNAVAILABLE) {
      this.router.navigate(["error/services-unavailable"]);
    } else if (status === SessionStatus.INVALID) {
      this.router.navigate(["error/authentication-failed"]);
    }
  }
}
